import { disposeObjectRecursively } from './object3d-utility';
import { Scene } from 'three';

export function clearScene(scene: Scene | undefined): void {
  if (!scene) {
    return;
  }

  while (scene.children.length > 0) {
    const object = scene.children[0];
    disposeObjectRecursively(object);
    scene.remove(object);
  }
}
